export default "__VITE_ASSET__6jfd8$qd__"